(function () {
  if (window.location.origin === 'https://alfaleads.eu') return;

  urlParams = new URLSearchParams(window.location.search);
  clickId = urlParams.get('clickid');
  if (!getCookie('regClickId') && clickId) {

    var d = new Date();
    d.setTime(d.getTime() + (24 * 60 * 60 * 1000 * 7));
    var expires = ";path=/;expires=" + d.toUTCString();

    document.cookie = 'regClickId=' + clickId + expires;
  }

  function getCookie(name) {
    var matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));

    return matches ? decodeURIComponent(matches[1]) : undefined;
  }
})();
